import React from 'react';

import { experience } from './payload';
import { ExperienceSection as SPEExperienceSection } from '../../spe-ne';

export const OurExperienceSection = () => (
  <SPEExperienceSection
    desc="Low-level programming is our thing. We build solutions that integrate programmable hardware with SDN software."
    payload={experience}
    id="spe-low-level-programming-experience"
  />
);
